import type { TypedOperation } from "./TypedOperation";

export interface Delta<_RType = unknown> {
  // biome-ignore lint/suspicious/noExplicitAny: legacy code
  [key: string]: any;
  // biome-ignore lint/suspicious/noExplicitAny: legacy code
  [key: number]: any;
}

export interface AtomPatchesPacket<AtomType = unknown> {
  __patches: TypedOperation<AtomType>[];
  hash?: string;
}

export interface AtomDeltaPacket<RType = unknown> {
  __delta: Delta<RType>;
}

export interface AtomDoesNotExistPacket {
  __doesNotExist: true;
}

export interface AtomFullValuePacket<RType = unknown> {
  __value: RType;
}

export type SubscribeAtomPacket<RType = unknown, _AtomType = unknown> =
  | RType
  | AtomPatchesPacket<RType>
  | AtomDeltaPacket<RType>
  | AtomDoesNotExistPacket
  | AtomFullValuePacket<RType>;

export const isAtomPatchesPacket = <RType extends object = object>(
  packet: SubscribeAtomPacket<RType>,
): packet is AtomPatchesPacket<RType> => {
  return "__patches" in packet;
};

export const isAtomDeltaPacket = <RType extends object = object>(
  packet: SubscribeAtomPacket<RType>,
): packet is AtomDeltaPacket<RType> => {
  return "__delta" in packet;
};
